import { gql } from 'graphql-request'

export const CREATE_COIN = gql`
  mutation CreateCoin($createCoinInput: CreateCoinInput!) {
    createCoin(createCoinInput: $createCoinInput) {
      id
    }
  }
`
